(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("cornerstoneDICOMImageLoader", [], factory);
	else if(typeof exports === 'object')
		exports["cornerstoneDICOMImageLoader"] = factory();
	else
		root["cornerstoneDICOMImageLoader"] = factory();
})(this, () => {
return 